import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProviderService } from '@services/provider.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { SelectModule } from 'primeng/select';
import { ToastService } from '@utils/toast.service';
import { TableModule } from 'primeng/table';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SatService } from '@services/sat.service';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'app-upload',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TabViewModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    InputGroup,
    IconFieldModule,
    InputIconModule,
    InputMaskModule,
  ],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
})
export class UploadComponent {
  private formBuilder = inject(FormBuilder);
  private satService = inject(SatService);
  private providerService = inject(ProviderService);
  private toastService = inject(ToastService);

  public isSaving = false;

  public formUpload = this.formBuilder.group({
    rfc: [null, Validators.required],
    provider: [null, [Validators.required]],
  });

  public providers: any[] = [];
  public list: any[] = [];
  public searchValue: string | undefined;

  ngOnInit() {
    this.providerService.module('sat-contrasena-ciec-ine').then((data) => (this.providers = data));

    this.refresh();
  }

  refresh = async () => {
    await this.satService.contrasenaCiecIneList().then((response) => (this.list = response));
  };

  get rfc() {
    return this.formUpload.get('rfc');
  }
  set rfc(value: any) {
    this.rfc.setValue(value);
  }

  get provider() {
    return this.formUpload.get('provider');
  }

  save = async () => {
    this.isSaving = true;

    const myFormData = new FormData();

    myFormData.append('rfc', this.rfc.value);
    myFormData.append('provider', this.provider?.value ?? '');

    this.satService
      .contrasenaCiecIneCreate(myFormData)
      .then(() => {
        this.toastService.success('Guardado');
        this.formUpload.reset();
        this.refresh();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error.');
      })
      .finally(() => (this.isSaving = false));
  };
}
